import React from 'react';

const FirefoxIcon = () => {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.3271 8.38686C22.8006 7.12009 21.7327 5.75234 20.8964 5.31997C21.4929 6.47517 21.9068 7.7158 22.1235 8.99773L22.1257 9.01805C20.7557 5.60259 18.4326 4.22546 16.5352 1.22673C16.4393 1.0751 16.3433 0.923165 16.2498 0.762787C16.1963 0.671187 16.1535 0.588653 16.1163 0.512684C16.0376 0.360294 15.977 0.199244 15.9356 0.0327993C15.9357 0.0251187 15.9329 0.0176864 15.9278 0.0119203C15.9227 0.00615426 15.9157 0.00245791 15.9081 0.00153641C15.9006 -0.000512138 15.8927 -0.000512138 15.8853 0.00153641C15.8837 0.00153641 15.8812 0.00435007 15.8793 0.00497533C15.8775 0.00560058 15.8734 0.00841424 15.8706 0.00966475L15.8753 0.00153641C12.8318 1.78352 11.7992 5.08237 11.7042 6.73243C10.4888 6.81597 9.32676 7.26385 8.36969 8.01764C8.26984 7.93306 8.16547 7.85396 8.05706 7.78067C7.78097 6.81432 7.76921 5.79159 8.02298 4.81914C6.90532 5.36059 5.9122 6.12813 5.10647 7.07319H5.10085C4.62065 6.4645 4.65441 4.45743 4.68192 4.0382C4.53986 4.09529 4.40426 4.16728 4.27738 4.25297C3.85347 4.55552 3.45718 4.89501 3.09315 5.26745C2.67832 5.68804 2.29944 6.14262 1.96049 6.62645V6.62832V6.62613C1.1815 7.73051 0.628976 8.97826 0.334825 10.2973L0.318568 10.3774C0.295747 10.484 0.213525 11.0179 0.199457 11.1339C0.199457 11.143 0.197581 11.1514 0.196643 11.1605C0.0905803 11.7118 0.0248582 12.27 0 12.8309L0 12.8934C0.00265644 15.9272 1.14329 18.8497 3.19647 21.0832C5.24966 23.3167 8.066 24.6988 11.0889 24.9562C14.1118 25.2137 17.1213 24.3278 19.5226 22.4737C21.9239 20.6195 23.5423 17.9321 24.058 14.9424C24.0783 14.7861 24.0949 14.6313 24.113 14.4734C24.3626 12.4108 24.0924 10.3185 23.3271 8.38686ZM9.36197 17.8714C9.41856 17.8986 9.4717 17.928 9.52985 17.9539L9.53829 17.9592C9.47952 17.9311 9.42074 17.9018 9.36197 17.8714ZM22.1266 9.02087V9.0093L22.1288 9.02212L22.1266 9.02087Z"
        fill="url(#paint0_linear_2802_147)"
      />
      <path
        d="M23.3271 8.38695C22.8006 7.12018 21.7327 5.75243 20.8964 5.32007C21.4929 6.47527 21.9068 7.7159 22.1235 8.99783V9.0094L22.1257 9.02221C23.0596 11.6947 22.9245 14.6247 21.7486 17.1999C20.3599 20.1796 16.9985 23.2337 11.737 23.0852C6.05186 22.9242 1.04512 18.7056 0.109107 13.1802C-0.0612752 12.3089 0.109107 11.8671 0.194768 11.159C0.0779156 11.7091 0.0127097 12.2688 0 12.831L0 12.8935C0.00265644 15.9273 1.14329 18.8498 3.19647 21.0833C5.24966 23.3168 8.066 24.6989 11.0889 24.9563C14.1118 25.2138 17.1213 24.3279 19.5226 22.4738C21.9239 20.6196 23.5423 17.9321 24.058 14.9425C24.0783 14.7861 24.0949 14.6314 24.113 14.4735C24.3626 12.4109 24.0924 10.3186 23.3271 8.38695Z"
        fill="url(#paint1_radial_2802_147)"
      />
      <path
        d="M23.3271 8.38695C22.8006 7.12018 21.7327 5.75243 20.8964 5.32007C21.4929 6.47527 21.9068 7.7159 22.1235 8.99783V9.0094L22.1257 9.02221C23.0596 11.6947 22.9245 14.6247 21.7486 17.1999C20.3599 20.1796 16.9985 23.2337 11.737 23.0852C6.05186 22.9242 1.04512 18.7056 0.109107 13.1802C-0.0612752 12.3089 0.109107 11.8671 0.194768 11.159C0.0779156 11.7091 0.0127097 12.2688 0 12.831L0 12.8935C0.00265644 15.9273 1.14329 18.8498 3.19647 21.0833C5.24966 23.3168 8.066 24.6989 11.0889 24.9563C14.1118 25.2138 17.1213 24.3279 19.5226 22.4738C21.9239 20.6196 23.5423 17.9321 24.058 14.9425C24.0783 14.7861 24.0949 14.6314 24.113 14.4735C24.3626 12.4109 24.0924 10.3186 23.3271 8.38695Z"
        fill="url(#paint2_radial_2802_147)"
      />
      <path
        d="M17.4399 9.81112C17.4662 9.82956 17.4906 9.84801 17.5153 9.86646C17.2109 9.32676 16.832 8.83264 16.3898 8.39866C12.6239 4.63212 15.4028 0.231872 15.8715 0.00834267L15.8762 0.00146484C12.8327 1.78345 11.8001 5.0823 11.7051 6.73236C11.8464 6.72266 11.9864 6.71078 12.1309 6.71078C13.2108 6.71276 14.2708 7.00067 15.2034 7.54523C16.1359 8.0898 16.9076 8.87159 17.4399 9.81112Z"
        fill="url(#paint3_radial_2802_147)"
      />
      <path
        d="M12.1377 10.5635C12.1177 10.8648 11.0529 11.9043 10.6806 11.9043C7.23507 11.9043 6.67578 13.9886 6.67578 13.9886C6.82834 15.7437 8.05135 17.1893 9.52977 17.954C9.59729 17.989 9.66576 18.0206 9.73423 18.0515C9.85282 18.1041 9.97141 18.1526 10.09 18.1972C10.5974 18.3768 11.1288 18.4793 11.6666 18.5014C17.7056 18.7846 18.8755 11.2797 14.5174 9.10192C15.5455 8.96815 16.5867 9.22094 17.439 9.81127C16.9066 8.87174 16.1349 8.08995 15.2024 7.54539C14.2699 7.00082 13.2098 6.71292 12.1299 6.71094C11.9861 6.71094 11.8454 6.72282 11.7041 6.73251C10.4887 6.81605 9.32667 7.26393 8.3696 8.01772C8.55437 8.17404 8.76289 8.38287 9.20213 8.81586C10.0243 9.62589 12.133 10.465 12.1377 10.5635Z"
        fill="url(#paint4_radial_2802_147)"
      />
      <path
        d="M12.1377 10.5635C12.1177 10.8648 11.0529 11.9043 10.6806 11.9043C7.23507 11.9043 6.67578 13.9886 6.67578 13.9886C6.82834 15.7437 8.05135 17.1893 9.52977 17.954C9.59729 17.989 9.66576 18.0206 9.73423 18.0515C9.85282 18.1041 9.97141 18.1526 10.09 18.1972C10.5974 18.3768 11.1288 18.4793 11.6666 18.5014C17.7056 18.7846 18.8755 11.2797 14.5174 9.10192C15.5455 8.96815 16.5867 9.22094 17.439 9.81127C16.9066 8.87174 16.1349 8.08995 15.2024 7.54539C14.2699 7.00082 13.2098 6.71292 12.1299 6.71094C11.9861 6.71094 11.8454 6.72282 11.7041 6.73251C10.4887 6.81605 9.32667 7.26393 8.3696 8.01772C8.55437 8.17404 8.76289 8.38287 9.20213 8.81586C10.0243 9.62589 12.133 10.465 12.1377 10.5635Z"
        fill="url(#paint5_radial_2802_147)"
      />
      <path
        d="M7.804 7.61462C7.90217 7.67714 7.98314 7.73154 8.0541 7.78062C7.77802 6.81427 7.76625 5.79154 8.02003 4.81909C6.90236 5.36054 5.90924 6.12808 5.10352 7.07314C5.1626 7.07158 6.9202 7.04 7.804 7.61462Z"
        fill="url(#paint6_radial_2802_147)"
      />
      <path
        d="M0.111514 13.18C1.04659 18.7054 6.05427 22.924 11.7394 23.085C17.001 23.2338 20.3623 20.1795 21.751 17.1998C22.9269 14.6246 23.062 11.6945 22.1281 9.02206V9.01049C22.1281 9.00142 22.1262 8.99611 22.1281 8.99892L22.1302 9.01924C22.5601 11.8257 21.1327 14.5446 18.9011 16.3832L18.8942 16.3988C14.5462 19.94 10.3851 18.5353 9.54289 17.962C9.48411 17.9338 9.42534 17.9046 9.36657 17.8741C6.83146 16.6624 5.78416 14.3527 6.00862 12.3719C5.40685 12.3808 4.81541 12.2149 4.30597 11.8945C3.79653 11.574 3.39095 11.1127 3.13838 10.5664C3.80385 10.1588 4.56263 9.92828 5.34242 9.89698C6.12221 9.86567 6.89702 10.0346 7.59303 10.3876C9.02794 11.039 10.6608 11.1032 12.1424 10.5664C12.1377 10.468 10.029 9.62856 9.20681 8.81885C8.76757 8.38586 8.55905 8.17733 8.37428 8.02071C8.27443 7.93613 8.17007 7.85702 8.06166 7.78374C7.98975 7.73465 7.90878 7.68151 7.81155 7.61773C6.92775 7.04312 5.17016 7.07469 5.11201 7.07626H5.10638C4.62618 6.46757 4.65995 4.46049 4.68746 4.04126C4.5454 4.09835 4.40979 4.17035 4.28292 4.25604C3.85901 4.55858 3.46271 4.89807 3.09868 5.27051C2.68237 5.68992 2.30192 6.14346 1.96134 6.62638V6.62826V6.62607C1.18234 7.73045 0.62982 8.97819 0.335669 10.2973C0.329729 10.322 -0.100761 12.204 0.111514 13.18Z"
        fill="url(#paint7_radial_2802_147)"
      />
      <path
        d="M16.3888 8.39874C16.8312 8.83319 17.2101 9.32785 17.5143 9.86809C17.5809 9.91842 17.6431 9.96844 17.6959 10.0169C20.443 12.5492 19.0037 16.1288 18.8964 16.3836C21.128 14.545 22.5542 11.8261 22.1256 9.01962C20.755 5.60259 18.4319 4.22546 16.5345 1.22673C16.4385 1.0751 16.3426 0.923165 16.2491 0.762787C16.1956 0.671187 16.1528 0.588653 16.1156 0.512684C16.0369 0.360294 15.9763 0.199244 15.9349 0.0327993C15.935 0.0251187 15.9322 0.0176864 15.9271 0.0119203C15.922 0.00615426 15.915 0.00245791 15.9074 0.00153641C15.8999 -0.000512138 15.892 -0.000512138 15.8846 0.00153641C15.883 0.00153641 15.8805 0.00435007 15.8786 0.00497533C15.8768 0.00560058 15.8727 0.00841424 15.8699 0.00966475C15.4012 0.231944 12.6223 4.63219 16.3888 8.39874Z"
        fill="url(#paint8_radial_2802_147)"
      />
      <path
        d="M17.6955 10.0154C17.6426 9.96691 17.5804 9.91689 17.5138 9.86656C17.4891 9.84812 17.4647 9.82967 17.4385 9.81123C16.5862 9.22089 15.5451 8.9681 14.517 9.10187C18.875 11.2809 17.7058 18.7846 11.6661 18.5014C11.1283 18.4793 10.5969 18.3767 10.0895 18.1972C9.97094 18.1528 9.85235 18.1042 9.73376 18.0515C9.66529 18.0202 9.59682 17.989 9.5293 17.9539L9.53774 17.9593C10.38 18.5342 14.5398 19.9388 18.8891 16.3961L18.896 16.3805C19.0044 16.1273 20.4438 12.5467 17.6955 10.0154Z"
        fill="url(#paint9_radial_2802_147)"
      />
      <path
        d="M6.67685 13.9884C6.67685 13.9884 7.23614 11.9041 10.6816 11.9041C11.054 11.9041 12.1197 10.8647 12.1388 10.5633C10.6572 11.1 9.02433 11.0359 7.58941 10.3845C6.89341 10.0314 6.11859 9.86251 5.3388 9.89382C4.55901 9.92512 3.80023 10.1556 3.13477 10.5633C3.38734 11.1096 3.79291 11.5709 4.30235 11.8913C4.81179 12.2118 5.40323 12.3776 6.00501 12.3687C5.78054 14.3498 6.82784 16.6595 9.36295 17.871C9.41953 17.8982 9.47268 17.9276 9.53083 17.9535C8.05116 17.1891 6.82941 15.7435 6.67685 13.9884Z"
        fill="url(#paint10_radial_2802_147)"
      />
      <path
        d="M23.3271 8.38686C22.8006 7.12009 21.7327 5.75234 20.8964 5.31997C21.4929 6.47517 21.9068 7.7158 22.1235 8.99773L22.1257 9.01805C20.7557 5.60259 18.4326 4.22546 16.5352 1.22673C16.4393 1.0751 16.3433 0.923165 16.2498 0.762787C16.1963 0.671187 16.1535 0.588653 16.1163 0.512684C16.0376 0.360294 15.977 0.199244 15.9356 0.0327993C15.9357 0.0251187 15.9329 0.0176864 15.9278 0.0119203C15.9227 0.00615426 15.9157 0.00245791 15.9081 0.00153641C15.9006 -0.000512138 15.8927 -0.000512138 15.8853 0.00153641C15.8837 0.00153641 15.8812 0.00435007 15.8793 0.00497533C15.8775 0.00560058 15.8734 0.00841424 15.8706 0.00966475L15.8753 0.00153641C12.8318 1.78352 11.7992 5.08237 11.7042 6.73243C11.8455 6.72274 11.9855 6.71086 12.13 6.71086C13.2099 6.71283 14.27 7.00074 15.2025 7.54531C16.135 8.08987 16.9067 8.87166 17.439 9.81119C16.5868 9.22086 15.5456 8.96807 14.5175 9.10184C18.8756 11.2809 17.7063 18.7846 11.6667 18.5013C11.1289 18.4792 10.5975 18.3767 10.0901 18.1971C9.97149 18.1527 9.8529 18.1042 9.73431 18.0515C9.66584 18.0202 9.59738 17.9889 9.52985 17.9539L9.53829 17.9592C9.47952 17.9311 9.42074 17.9018 9.36197 17.8714C9.41856 17.8986 9.4717 17.928 9.52985 17.9539C8.05018 17.1892 6.82843 15.7436 6.67587 13.9885C6.67587 13.9885 7.23516 11.9042 10.6806 11.9042C11.053 11.9042 12.1187 10.8648 12.1378 10.5634C12.1331 10.4649 10.0244 9.62549 9.20222 8.81578C8.76297 8.38279 8.55445 8.17427 8.36969 8.01764C8.26984 7.93306 8.16547 7.85396 8.05706 7.78067C7.78097 6.81432 7.76921 5.79159 8.02298 4.81914C6.90532 5.36059 5.9122 6.12813 5.10647 7.07319H5.10085C4.62065 6.4645 4.65441 4.45743 4.68192 4.0382C4.53986 4.09529 4.40426 4.16728 4.27738 4.25297C3.85347 4.55552 3.45718 4.89501 3.09315 5.26745C2.67832 5.68804 2.29944 6.14262 1.96049 6.62645V6.62832V6.62613C1.1815 7.73051 0.628976 8.97826 0.334825 10.2973L0.318568 10.3774C0.295747 10.484 0.193517 11.0254 0.178823 11.1417C0.178823 11.1327 0.178823 11.1505 0.178823 11.1417C0.0853196 11.7007 0.0256034 12.2647 0 12.8309L0 12.8934C0.00265644 15.9272 1.14329 18.8497 3.19647 21.0832C5.24966 23.3167 8.066 24.6988 11.0889 24.9562C14.1118 25.2137 17.1213 24.3278 19.5226 22.4737C21.9239 20.6195 23.5423 17.9321 24.058 14.9424C24.0783 14.7861 24.0949 14.6313 24.113 14.4734C24.3626 12.4108 24.0924 10.3185 23.3271 8.38686ZM22.125 9.0093L22.1272 9.02212L22.125 9.0093Z"
        fill="url(#paint11_linear_2802_147)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2802_147"
          x1="21.7233"
          y1="3.87313"
          x2="1.60909"
          y2="23.2795"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.048" stopColor="#FFF44F" />
          <stop offset="0.111" stopColor="#FFE847" />
          <stop offset="0.225" stopColor="#FFC830" />
          <stop offset="0.368" stopColor="#FF980E" />
          <stop offset="0.401" stopColor="#FF8B16" />
          <stop offset="0.462" stopColor="#FF672A" />
          <stop offset="0.534" stopColor="#FF3647" />
          <stop offset="0.705" stopColor="#E31587" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_2802_147"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(20.7939 2.77458) scale(25.2594 25.2594)"
        >
          <stop offset="0.129" stopColor="#FFBD4F" />
          <stop offset="0.186" stopColor="#FFAC31" />
          <stop offset="0.247" stopColor="#FF9D17" />
          <stop offset="0.283" stopColor="#FF980E" />
          <stop offset="0.403" stopColor="#FF563B" />
          <stop offset="0.467" stopColor="#FF3750" />
          <stop offset="0.71" stopColor="#F5156C" />
          <stop offset="0.782" stopColor="#EB0878" />
          <stop offset="0.86" stopColor="#E50080" />
        </radialGradient>
        <radialGradient
          id="paint2_radial_2802_147"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.5638 13.1014) scale(25.2594 25.2594)"
        >
          <stop offset="0.3" stopColor="#960E18" />
          <stop offset="0.351" stopColor="#B11927" stopOpacity="0.74" />
          <stop offset="0.435" stopColor="#DB293D" stopOpacity="0.343" />
          <stop offset="0.497" stopColor="#F5334B" stopOpacity="0.094" />
          <stop offset="0.53" stopColor="#FF3750" stopOpacity="0" />
        </radialGradient>
        <radialGradient
          id="paint3_radial_2802_147"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.61 -2.95791) scale(18.2994 18.2994)"
        >
          <stop offset="0.132" stopColor="#FFF44F" />
          <stop offset="0.252" stopColor="#FFDC3E" />
          <stop offset="0.506" stopColor="#FF9D12" />
          <stop offset="0.526" stopColor="#FF980E" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_2802_147"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(8.7698 19.6992) scale(12.0271 12.0271)"
        >
          <stop offset="0.353" stopColor="#3A8EE6" />
          <stop offset="0.472" stopColor="#5C79F0" />
          <stop offset="0.669" stopColor="#9059FF" />
          <stop offset="1" stopColor="#C139E6" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_2802_147"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(12.944 11.0313) rotate(-13.5916) scale(6.37671 7.46554)"
        >
          <stop offset="0.206" stopColor="#9059FF" stopOpacity="0" />
          <stop offset="0.278" stopColor="#8C4FF3" stopOpacity="0.064" />
          <stop offset="0.747" stopColor="#7716A8" stopOpacity="0.45" />
          <stop offset="0.975" stopColor="#6E008B" stopOpacity="0.6" />
        </radialGradient>
        <radialGradient
          id="paint6_radial_2802_147"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.2442 1.74098) scale(8.6523)"
        >
          <stop stopColor="#FFE226" />
          <stop offset="0.121" stopColor="#FFDB27" />
          <stop offset="0.295" stopColor="#FFC82A" />
          <stop offset="0.502" stopColor="#FFA930" />
          <stop offset="0.732" stopColor="#FF7E37" />
          <stop offset="0.792" stopColor="#FF7139" />
        </radialGradient>
        <radialGradient
          id="paint7_radial_2802_147"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(18.0467 -3.7471) scale(36.9155 36.9155)"
        >
          <stop offset="0.113" stopColor="#FFF44F" />
          <stop offset="0.456" stopColor="#FF980E" />
          <stop offset="0.622" stopColor="#FF5634" />
          <stop offset="0.716" stopColor="#FF3647" />
          <stop offset="0.904" stopColor="#E31587" />
        </radialGradient>
        <radialGradient
          id="paint8_radial_2802_147"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(14.9338 -1.69434) rotate(83.976) scale(27.0562 17.7568)"
        >
          <stop stopColor="#FFF44F" />
          <stop offset="0.06" stopColor="#FFE847" />
          <stop offset="0.168" stopColor="#FFC830" />
          <stop offset="0.304" stopColor="#FF980E" />
          <stop offset="0.356" stopColor="#FF8B16" />
          <stop offset="0.455" stopColor="#FF672A" />
          <stop offset="0.57" stopColor="#FF3647" />
          <stop offset="0.737" stopColor="#E31587" />
        </radialGradient>
        <radialGradient
          id="paint9_radial_2802_147"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.0419 4.94582) scale(23.047)"
        >
          <stop offset="0.137" stopColor="#FFF44F" />
          <stop offset="0.48" stopColor="#FF980E" />
          <stop offset="0.592" stopColor="#FF5634" />
          <stop offset="0.655" stopColor="#FF3647" />
          <stop offset="0.904" stopColor="#E31587" />
        </radialGradient>
        <radialGradient
          id="paint10_radial_2802_147"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(17.1259 6.29452) scale(25.2247 25.2247)"
        >
          <stop offset="0.094" stopColor="#FFF44F" />
          <stop offset="0.231" stopColor="#FFE141" />
          <stop offset="0.509" stopColor="#FFAF1E" />
          <stop offset="0.626" stopColor="#FF980E" />
        </radialGradient>
        <linearGradient
          id="paint11_linear_2802_147"
          x1="21.4816"
          y1="3.76934"
          x2="4.36648"
          y2="20.8842"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.167" stopColor="#FFF44F" stopOpacity="0.8" />
          <stop offset="0.266" stopColor="#FFF44F" stopOpacity="0.634" />
          <stop offset="0.489" stopColor="#FFF44F" stopOpacity="0.217" />
          <stop offset="0.6" stopColor="#FFF44F" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default FirefoxIcon;